jQuery(document).ready(function ($) {

    var CW_theme_framework = (function () {

        var originalJs = function () {

            $('.grid-story').masonry({
                // set itemSelector so .grid-sizer is not used in layout
                itemSelector: '.item-story',
                columnWidth: '.grid-sizer',
                percentPosition: true
            })

            // Location .squares-grid fix removing <br> tags
            $('.squares-grid').find('> br').remove();

            $('input, textarea').on('focus', function () {
                if ($(this).attr('placeholder')) $(this).data('placeholder', $(this).attr('placeholder')).removeAttr('placeholder');
            }).on('blur', function () {
                if ($(this).data('placeholder')) $(this).attr('placeholder', $(this).data('placeholder')).removeData('placeholder');
            });

            //Skip Link test2
            var skipLink = function () {
                $(".skiplink").focusin(function () {
                    $(this).css("position", "static");
                });

                $(".skiplink").focusout(function () {
                    $(this).css("position", "absolute");
                });
            }

            //No comments
            $("#commentform").addClass("noauto");

            //Hover for Desktop, click for mobile nav
            /*if ($(window).width() > 767) {
                $('.dropdown').on('mouseenter mouseleave click tap', function() {
                    $(this).toggleClass("open");
                });
            }*/

        };

        var tableOfContents = function () {

            if ($('.page-template-practice-area .qa-faqs .qa-faq-anchor').length > 0) {

                $('.page-template-practice-area .qa-faqs .qa-faq-anchor').each(function (index, el) {
                    let link = $(this).attr('href');
                    let link_params = link.split("/");
                    let link_id = link_params[link_params.length - 2];
                    $(this).attr('id', link_id);
                    $(this).addClass('toc-heading');
                });

            }

            var ToC = '';

            var newLine, el, title, link;

            $(".toc-heading").each(function () {

                el = $(this);
                title = el.text();
                link = "#" + el.attr("id");

                newLine =
                    "<li>" +
                    "<a class='toc-link' href='" + link + "'>" +
                    title +
                    "</a>" +
                    "</li>";

                ToC += newLine;

            });

            //console.log(ToC);

            //ToC += "</ul></div></div></div>";

            $(".toc-table ul").prepend(ToC);

            //$('.toc-table ul').smoothScroll();

            $(".toc-link:empty").each(function () {
                $(this).parent().css({
                    display: 'none'
                });
            });

        };

        var sameHeight = function () {

            $(window).load(function () {

                if ($('.grid-attorney .attorney-item').length > 0) {
                    $('.grid-attorney .attorney-item').matchHeight();
                }

                if ($('.team-part .team-wrap .grid-team .item').length > 0) {
                    $('.team-part .team-wrap .grid-team .item').matchHeight();
                }

                if ($('.grid-videos .video-description').length > 0) {
                    $('.grid-videos .video-description').matchHeight();
                }

                if ($('.grid-results .item').length > 0) {
                    $('.grid-results .item').matchHeight();
                }

                if ($('.contact-sidebar .col-item').length > 0) {
                    $('.contact-sidebar .col-item').matchHeight();
                }

                if ($('.home .grid-info .item .img-wrap').length > 0) {
                    $('.home .grid-info .item .img-wrap').matchHeight();
                }

            });

        };

        var scrollToSection = function () {

            var scroll = new SmoothScroll('a[href*="#"]:not(.page-link)', {
                // Selectors
                ignore: '[data-scroll-ignore]', // Selector for links to ignore (must be a valid CSS selector)
                header: null, // Selector for fixed headers (must be a valid CSS selector)
                topOnEmptyHash: true, // Scroll to the top of the page for links with href="#"
                speed: 500, // Integer. Amount of time in milliseconds it should take to scroll 1000px
                speedAsDuration: false, // If true, use speed as the total duration of the scroll animation
                durationMax: null, // Integer. The maximum amount of time the scroll animation should take
                durationMin: null, // Integer. The minimum amount of time the scroll animation should take
                clip: true, // If true, adjust scroll distance to prevent abrupt stops near the bottom of the page
                offset: 0,
                updateURL: false,
                popstate: false,
                // Easing
                easing: 'easeInOutCubic', // Easing pattern to use
                customEasing: function (time) {
                    // Function. Custom easing pattern
                    // If this is set to anything other than null, will override the easing option above

                    // return <your formulate with time as a multiplier>

                    // Example: easeInOut Quad
                    return time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time;
                }
            });

        };

        var requiredInput = function () {

            $('.input-required').on('focus', function () {
                if ($(this).parent().data('required') == 'required') {
                    $(this).parent().removeClass('required');
                }
            });

            $('.input-required').on('blur', function () {
                if ($(this).val() == '') {
                    $(this).parent().addClass('required');
                }
            });

        };

        var hoverMenu = function () {

            function fnIsAppleMobile() {
                if (navigator && navigator.userAgent && navigator.userAgent != null) {
                    var strUserAgent = navigator.userAgent.toLowerCase();
                    var arrMatches = strUserAgent.match(/(iphone|ipod|ipad)/);
                    if (arrMatches != null)
                        return true;
                } // End if (navigator && navigator.userAgent)

                return false;
            } // End Function fnIsAppleMobile

            var bIsAppleMobile = fnIsAppleMobile();

            if ($(window).width() >= 768) {

                if (!bIsAppleMobile) {

                    const $dropdown = $(".dropdown");
                    const $dropdownToggle = $(".dropdown-toggle");
                    const $dropdownMenu = $(".dropdown-menu");
                    const showClass = "show";

                    $(window).on("load resize", function () {
                        if (this.matchMedia("(min-width: 768px)").matches) {
                            $dropdown.hover(
                                function () {
                                    const $this = $(this);
                                    $this.addClass(showClass);
                                    $this.find($dropdownToggle).attr("aria-expanded", "true");
                                    $this.find($dropdownMenu).addClass(showClass);
                                },
                                function () {
                                    const $this = $(this);
                                    $this.removeClass(showClass);
                                    $this.find($dropdownToggle).attr("aria-expanded", "false");
                                    $this.find($dropdownMenu).removeClass(showClass);
                                }
                            );
                        } else {
                            $dropdown.off("mouseenter mouseleave");
                        }
                    });

                    // $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
                    //
                    //     if (!$(this).next().hasClass('show')) {
                    //         $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
                    //     }
                    //
                    //     var $subMenu = $(this).next(".dropdown-menu");
                    //
                    //     $subMenu.toggleClass('show');
                    //
                    //     $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
                    //         $('.dropdown-submenu .show').removeClass("show");
                    //     });
                    //
                    //     return false;
                    //
                    // });

                }

            } else {

                $('#nav-mobile .nav-link.dropdown-toggle').on('click', function () {
                    $(this).next().slideToggle();
                });

            }


        };

        var carousels = function () {

            if ($(window).width() <= 767) {

                let yt_videos = $(".grid-videos");
                yt_videos.slick({
                    dots: true,
                    arrows: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                infinite: true,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                        // You can unslick at a given breakpoint now by adding:
                        // settings: "unslick"
                        // instead of a settings object
                    ]
                });

                var results = $(".results-slider .grid-results");
                results.slick({
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    appendArrows: '.custom-nav-results',
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                                arrows: false
                            }
                        }
                        // You can unslick at a given breakpoint now by adding:
                        // settings: "unslick"
                        // instead of a settings object
                    ]
                });

            }

            var team = $(".slider-team");

            team.slick({
                dots: false,
                arrows: true,
                infinite: true,
                appendArrows: '.custom-nav-team',
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });

            let testimonials_home = $('.testimonials-home-slider');

            testimonials_home.slick(
                {
                    dots: false,
                    arrows: true,
                    infinite: true,
                    adaptiveHeight: true,
                    appendArrows: '.custom-nav-testimonials-home'
                }
            );

            let stories = $('.stories-slider');

            stories.slick(
                {
                    dots: false,
                    arrows: true,
                    infinite: true,
                    adaptiveHeight: true,
                    appendArrows: '.custom-nav-stories',
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                                arrows: false
                            }
                        }
                        // You can unslick at a given breakpoint now by adding:
                        // settings: "unslick"
                        // instead of a settings object
                    ]
                }
            );

            var awards = $(".awards-wrap");

            awards.slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 6,
                slidesToScroll: 1,
                appendArrows: '.custom-nav-awards',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });

            $(window).load(function () {

                $('.awards-part .item').matchHeight();

                $('.awards-part .sameHeight').matchHeight();

            });

            var testimonials = $('.testimonials-section-slider');

            testimonials.slick({
                dots: false,
                infinite: true,
                appendArrows: '.custom-nav-test',
            });

            if ($('.results-slider__sidebar .grid-results').length > 0) {

                var sidebar_results = $('.results-slider__sidebar .grid-results');

                sidebar_results.slick({
                    dots: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    appendArrows: '.custom-nav-results',
                });

            }

            if ($('.sidebar-team-slider').length > 0) {

                var sidebar_team = $('.sidebar-team-slider');

                sidebar_team.slick({
                    dots: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    appendArrows: '.custom-nav-sidebar-team',
                });

            }

        };

        var vueMain = function () {

            if ($("#app").length > 0) {
                require('./vue/vue-main.js');
            }

        };

        return {

            init: function () {
                originalJs();
                tableOfContents();
                sameHeight();
                scrollToSection();
                requiredInput();
                hoverMenu();
                carousels();
                vueMain();
            }

        }

    })();

    CW_theme_framework.init();

});